
import {
  computed,
  defineComponent,
  onMounted,
  provide,
  Ref,
  ref,
  watch
} from 'vue';
import type { BaseTab } from './types';

export default defineComponent({
  name: 'BaseTabs',

  props: {
    size: {
      type: String,
      default: 'md',
      validator: (value: string) => {
        return ['sm', 'md', 'lg'].includes(value);
      }
    },
    layout: {
      type: String,
      default: 'left',
      validator: (value: string) => {
        return ['left', 'fluid'].includes(value);
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  setup(props, context) {
    const tabs: Ref<BaseTab[]> = ref([]);

    provide('baseTabsProvider', {
      tabs,
      addTab(tab: BaseTab) {
        tabs.value.push(tab);
      },
      removeTab(title: string) {
        const tabIndex = tabs.value.findIndex((tab) => tab.id === title);
        tabs.value.splice(tabIndex, 1);
      }
    });

    const selectedTab = computed({
      get(): number {
        return props.value;
      },

      set(value: number) {
        context.emit('input', value);
      }
    });

    function selectTab(selectedTab: number) {
      tabs.value.forEach((tab, i) => {
        tab.selected = i === selectedTab;
      });
    }

    function handleTabClick(index: number) {
      selectedTab.value = index;
      selectTab(index);
      context.emit('tab-clicked');
    }

    watch(selectedTab, () => {
      selectTab(selectedTab.value);
    });

    onMounted(() => {
      selectTab(selectedTab.value);
    });

    return {
      tabs,
      handleTabClick
    };
  }
});
